import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getServerListData } from "@/api/gmtool/packageCode";
import { gmTool, customPaging } from "@/mixins/index";
export default {
  name: "examineList",
  mixins: [gmTool, customPaging],
  data: function data() {
    return {
      paramsData: {
        page: 1
      },
      drawer: false,
      versionList: []
    };
  },
  activated: function activated() {
    this.getList(this.currentPage);
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    openView: function openView(row) {
      this.versionList = row.version_list.map(function (i) {
        return {
          value: i,
          pkgName: row.pkg_name
        };
      });
      this.drawer = true;
    },
    getList: function getList() {
      var _this = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.currentPage = e;
      getServerListData(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this.tableCopyTableList = JSON.parse(JSON.stringify(res.data));
          _this.tableData = _this.currentChangePage(_this.pageSize, _this.currentPage);
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        if (_this2.tableData.findIndex(function (i) {
          return i.id == e.id;
        }) > -1) {
          _this2.sels.push(e.id);
        }
      });
      this.selsString = this.sels.toString();
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                examineServerDel(_objectSpread({
                  id: id
                }, _this3.paramsData)).then(function (res) {
                  if (res.status == 200) {
                    _this3.getList(_this3.paramsData.page);

                    _this3.$message({
                      type: "success",
                      message: '删除成功'
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};